import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';
import { Observable } from '@node_modules/rxjs';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@node_modules/@angular/common/http';
import { catchError, retryWhen, switchMap } from '@node_modules/rxjs/operators';
import { genericRetryStrategy } from '@shared/common/session/retry-strategy';
declare const abp: any;

// Extending AbpHttpInterceptor because Authorization header is not configurable
// https://github.com/aspnetboilerplate/abp-ng2-module/blob/master/projects/abp-ng2-module/src/lib/interceptors/abpHttpInterceptor.ts

const AUTH_HEADER_NAME = 'ASO-Authorization';
const BEARER = 'Bearer ';
/**
 * Request status codes that will trigger a retry
 */
const RETRY_REQUEST_STATUS_CODES = [401, 403];

@Injectable()
export class CustomAbpHttpInterceptor extends AbpHttpInterceptor {
    /**
     * Determines if the request should be retried
     * @param error
     */
    private shouldRetry = (error: HttpErrorResponse) => RETRY_REQUEST_STATUS_CODES.includes(error.status);

    /**
     * Overrides the default intercept method to add possible retries, then it executes the same as the parent class
     * @param request
     * @param next
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const modifiedRequest = this.normalizeRequestHeaders(request);
        
        // Check if retry should be skipped
        if(modifiedRequest?.headers.has('X-Skip-Retry') && modifiedRequest.headers.get('X-Skip-Retry') === 'true') {
            this.shouldRetry = (error: HttpErrorResponse) => false;
        }

        return next.handle(modifiedRequest).pipe(
            retryWhen(genericRetryStrategy({ shouldRetry: this.shouldRetry })),
            catchError((error) => {
                return this.handleErrorResponse(error);
            }),
            switchMap((event) => {
                return this.handleSuccessResponse(event);
            })
        );
    }

    /**
     * Handles the error response
     * @param error
     */
    handleErrorResponse(error: any): Observable<never> {
        return super.handleErrorResponse(error);
    }

    addAuthorizationHeaders(headers: HttpHeaders): HttpHeaders {
        let authorizationHeaders = headers ? headers.getAll(AUTH_HEADER_NAME) : null;
        if (!authorizationHeaders) {
            authorizationHeaders = [];
        }

        const bearerHeader = authorizationHeaders.find((item: string) => item.indexOf(BEARER) == 0);
        if (!bearerHeader) {
            let token = abp.auth.getToken();
            if (headers && token) {
                headers = headers.set(AUTH_HEADER_NAME, BEARER + token);
            }
        }
        return headers;
    }
}
